













import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSignOut } from '@fortawesome/pro-light-svg-icons';
import { User } from '@/types';

library.add(faSignOut);

@Component({
  name: 'top-nav'
})
export default class TopNav extends Vue {
  @State(state => state.UserMod.user)
  user!: User;

  @Action
  logout!: Function;
}
